import { LoadingButton } from "@mui/lab";
import { Checkbox, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../../request/Postrequest";
import Loader from "../../../../common/Loader";
import {
  DELETE_TIMESHEET_JOBS,
  FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT,
  SAVE_CLIENT_TIMESHEETS_NEW
} from "../../../../constant/Apipath";
import DeletConfirmModal from "../../promptModal/DeletConfirmModal";
import { VIEWS } from "./ClientTimesheetClockinComponent";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import { BIGrey } from "../../../../assets/helpers";
let CLIENT_COLOR = "#000000";
const TIMESHEET_STATUS = {
  IN_REVIEW: "1",
  APPROVED: "2",
  REJECTED: "3",
  IN_PROGRESS: "4"
};

function SelectJobModal({
  setView,
  setTimesheetID,
  timeSheetId,
  setSelectJobData,
  selectJobData,
  setList
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_EMPLOYEE_ID = selectedClientData?.ClientEmployeeId;
  const USER_ID = loginData?.userInformation?.UserId;
  const CLIENT_ID = selectedClientData?.ClientId;
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDeleteid, setCurrentDeleteid] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteDataObj, setDeleteDataObj] = useState(null);
  const [sortByNearby, setSortByNearby] = useState(false);
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0
  });
  const [jobs, setJobs] = useState([]);

  const {
    TEXT_SORT_BY,
    TEXT_NEAR_BY,
    TEXT_RECENT,
    BUTTON_NEXT,
    TEXT_SELECT_JOB_ACTIVITIES,
    TEXT_GEOLOCATION_NOT_SUPPORTED,
    TEXT_LOCATION_ACCESS_REQUIRED,
    TEXT_UNABLE_TO_ACCESS_LOCATION,
    TEXT_NO_JOBS_FOUND
  } = ClientEnglishFallback?.SelectJobModal(multiLanguageData?.SelectJobModal || {});

  const { TEXT_CANNOT_BE_UNDONE, TEXT_DELETE_HEADER } = ClientEnglishFallback?.ConfirmModal(
    multiLanguageData?.ConfirmModal || {}
  );

  useEffect(() => { }, []);

  useEffect(() => {
    fetchLocation();
    fetchjobsAndActivities();
  }, [sortByNearby]);
  const fetchLocation = async () => {
    if (!navigator.permissions || !navigator.geolocation) {
      console.warn("fetchLocation-> Geolocation or Permissions API not supported");
      return;
    }

    try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
      if (permissionStatus.state === "granted") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          },
          (err) => {
            console.warn("fetchLocation-> Location access denied or unavailable", err);
          }
        );
      }
    } catch (err) {
      console.error("fetchLocation-> Error accessing geolocation:", err);
    }
  };
  const fetchjobsAndActivities = async () => {
    setIsLoading(true);
    let userLatitude = 0;
    let userLongitude = 0;
    if (sortByNearby) {
      if (location?.latitude && location?.longitude) {
        userLatitude = location.latitude;
        userLongitude = location.longitude;
      } else {
        if (!navigator.permissions || !navigator.geolocation) {
          alert(TEXT_GEOLOCATION_NOT_SUPPORTED);
          setIsLoading(false);
          return;
        }

        try {
          const permissionStatus = await navigator.permissions.query({ name: "geolocation" });

          if (permissionStatus.state === "denied") {
            alert(TEXT_LOCATION_ACCESS_REQUIRED);
            setIsLoading(false);
            return;
          }

          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });

          userLatitude = position.coords.latitude;
          userLongitude = position.coords.longitude;

          setLocation({
            latitude: userLatitude,
            longitude: userLongitude
          });
        } catch (error) {
          alert(TEXT_UNABLE_TO_ACCESS_LOCATION);
          setIsLoading(false);
          return;
        }
      }
    }
    setIsLoading(true);
    try {
      const payload = {
        PageNumber: 1,
        NrRowsPerPage: 100,
        UserLatitude: userLatitude,
        UserLongitude: userLongitude,
        ClientId: CLIENT_ID,
        ClientEmployeeId: CLIENT_EMPLOYEE_ID,
        SortBy: sortByNearby ? 1 : 2
      };

      const response = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_AND_ACT, payload, TOKEN);
      let res = response.data.data;

      let data1 = res?.map((item) => {
        let actlist = item.clientJobActivitiesList.map((act) => {
          let data1 = null;
          selectJobData?.Act.forEach((item2) => {
            if (act.id === item2.actid) {
              data1 = item2;
            }
          });

          return {
            ...act,
            timesheetJobId: data1 ? data1.timesheetJobID : 0,
            selected: data1 ? true : false,
            isAlerady: data1 ? true : false
          };
        });

        let data = null;
        selectJobData?.jobs1.forEach((item2) => {
          if (item.clientJobId === item2.clientJobID) {
            data = item2;
          }
        });

        return {
          ...item,
          selected: data ? true : false,
          isAlerady: data ? true : false,
          clientJobActivitiesList: actlist,
          timesheetJobId: data ? data.timesheetJobID : 0
        };
      });

      setJobs(data1);
    } catch (error) {
      console.log('fetchjobsAndActivities-> Error When Fetching Client Jobs For Individual Timesheet: ', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handelJobClick = useCallback((job, index) => {
    if (job?.isAlerady && job?.timesheetJobId && job.clientJobActivitiesList.length === 0) {
      setCurrentDeleteid(job?.timesheetJobId);
      setConfirmModal(true);
      setDeleteDataObj({
        job: { ...job, isAlerady: false, timesheetJobId: 0 },
        jindex: index,
        aindex: null
      });
      return;
    }

    // Toggle job selection
    setJobs((prev) => {
      return prev?.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            selected: !item.selected
          };
        } else {
          return item;
        }
      });
    });
  }, []);

  const handelActivityClick = useCallback((job, jindex, aindex) => {
    const activity = job.clientJobActivitiesList[aindex];

    if (activity?.isAlerady && activity?.timesheetJobId) {
      setCurrentDeleteid(activity?.timesheetJobId);
      setConfirmModal(true);
      setDeleteDataObj({
        job: { ...activity, isAlerady: false, timesheetJobId: 0 },
        jindex: jindex,
        aindex: aindex
      });
      return;
    }

    setJobs((prev) => {
      return prev?.map((item, i) => {
        if (i === jindex) {
          let data = item.clientJobActivitiesList.map((act, acti) => {
            if (acti === aindex) {
              return {
                ...act,
                selected: !act.selected
              };
            }
            return act;
          });

          return {
            ...item,
            selected: data.some((item1) => item1.selected),
            clientJobActivitiesList: data
          };
        } else {
          return item;
        }
      });
    });
  }, []);

  const handelJobDelete = async () => {
    if (!currentDeleteid) return;
    try {
      setDeleteLoading(true);
      const deleteObj = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [{ Id: currentDeleteid }]
      };

      let res = await Postrequestcall(DELETE_TIMESHEET_JOBS, deleteObj, TOKEN);

      if (res.status === 201) {
        setSelectJobData((prev) => ({
          Act: prev.Act.filter((a) => a.timesheetJobID !== currentDeleteid),
          jobs1: prev.jobs1.filter((a) => a.timesheetJobID !== currentDeleteid)
        }));

        setJobs((prevJobs) => {
          return prevJobs.map((job, jIndex) => {
            if (jIndex === deleteDataObj.jindex) {
              if (deleteDataObj.aindex === null) {
                return {
                  ...job,
                  selected: false,
                  isAlerady: false,
                  timesheetJobId: 0
                };
              } else {
                const updatedActivities = job.clientJobActivitiesList.map((act, aIndex) => {
                  if (aIndex === deleteDataObj.aindex) {
                    return {
                      ...act,
                      selected: false,
                      isAlerady: false,
                      timesheetJobId: 0
                    };
                  }
                  return act;
                });

                const anyActivitySelected = updatedActivities.some(
                  (act) => act.selected || act.isAlerady
                );

                return {
                  ...job,
                  clientJobActivitiesList: updatedActivities,
                  selected: anyActivitySelected
                };
              }
            }
            return job;
          });
        });
      }
    } catch (error) {
      console.log('handelJobDelete-> Error When Deleting Client Timesheet Job: ', error);
    } finally {
      setConfirmModal(false);
      setDeleteLoading(false);
      setCurrentDeleteid(null);
      setDeleteDataObj(null);
    }
  };

  const getJobsUdFields = (data) => {
    if (data?.length > 0) {
      let temp = {};
      data?.map((item) => {
        temp[item.id] = item.fieldDefaultValue === "false" ? 0 : 1;
      });

      return JSON.stringify(temp);
    } else {
      return "";
    }
  };

  const isButtonDisabled = () => {
    let isDisabled = true;
    jobs.forEach((item) => {
      if (item.selected) {
        isDisabled = false;
      }
    });
    return isDisabled;
  };

  const handelAddorUpdatesJobs = async (temp) => {
    setLoading(true);
    try {
      let currentTimeSheetId = timeSheetId || 0;

      // Filter out already existing jobs and prepare all timeSheetJobList entries
      const timeSheetJobList = temp
        .filter(item => !item?.isAlerady)
        .map(item => ({
          Id: item?.timesheetJobId || 0,
          Notes: item?.notes || "",
          UDFields: getJobsUdFields(item.clientJobUDFieldsList) || "",
          Deleted: false,
          clockInTime: item?.clockInTime || "0:00",
          clockOutTime: item?.clockOutTime || "0:00",
          ClientJobId: item.clientJobId,
          ClientEmployeeId: CLIENT_EMPLOYEE_ID,
          ClientJobActivityId: item?.id || 0,
          clockInLatitude: item?.clockInLatitude || 0,
          clockOutLatitude: item?.clockOutLatitude || 0,
          clockInLongitude: item?.clockInLongitude || 0,
          clockOutLongitude: item?.clockOutLongitude || 0,
          ActivityUDFields: getJobsUdFields(item.clientActivitiesUDFieldsList) || "",
          Mileage: 0,
          MileageUnit: "km",
        }));

      // Only proceed if there are jobs to save
      if (timeSheetJobList.length === 0) {
        setView(VIEWS.LISTING);
        return;
      }

      const obj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: currentTimeSheetId,
            DateSubmitted: new Date(),
            Date: new Date(),
            TypeId: 3,
            StatusId: TIMESHEET_STATUS.IN_PROGRESS,
            ClientId: CLIENT_ID,
            Deleted: false,
            timeSheetJobList,
          },
        ],
      };

      const res = await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, obj, loginData?.accessToken);

      if (res.status === 201) {
        currentTimeSheetId = res.data.data[0].objData.ClientTimesheetId;
        setTimesheetID(currentTimeSheetId);
      } else {
        console.log('handelAddorUpdatesJobs-> Error Saving Client Timesheet');
      }

      setView(VIEWS.LISTING);
    } catch (error) {
      console.log('handelAddorUpdatesJobs-> Error Saving Client Timesheet: ', error);
    } finally {
      setLoading(false);
    }
  };


  const formatData = () => {
    let temp = [];
    jobs.forEach((item) => {
      if (item?.clientJobActivitiesList.length === 0 && item.selected) {
        temp.push({
          ...item,
          measureUnit: "Km",
          expanded: false,
          clockIn: "",
          clockOut: "",
          pictureList: []
        });
      } else if (item.selected) {
        item.clientJobActivitiesList.forEach((item1) => {
          if (item1.selected) {
            temp.push({
              clientActivitiesUDFieldsList: item1.clientActivitiesUDFieldsList,
              activityId: item1.id || 0,
              id: item1.id || 0,
              timesheetJobId: item1.timesheetJobId || 0,
              clientId: item1.clientId,
              isAlerady: item1.isAlerady,
              clientJobCode: item1.clientJobCode,
              clientJobId: item1.clientJobId,
              clientJobName: item1.clientJobName,
              clientLabourActivityId: item1.clientLabourActivityId,
              isQuantityApplicable: item1.isQuantityApplicable,
              labourActivityCode: item1.labourActivityCode,
              labourActivityName: item1.labourActivityName,
              organizationName: item1.organizationName,
              quantityUnit: item1.quantityUnit,
              selected: item1.selected,
              measureUnit: "km",
              expanded: false,
              clockIn: "",
              clockOut: "",
              pictureList: []
            });
          }
        });
      }
    });

    handelAddorUpdatesJobs(temp);
  };

  return (
    <>
      <DeletConfirmModal
        isOpen={confirmModal}
        loading={deleteLoading}
        onConfirm={() => {
          handelJobDelete();
        }}
        title={TEXT_CANNOT_BE_UNDONE}
        heading={TEXT_DELETE_HEADER}
        onClose={() => {
          setConfirmModal(false);
          setCurrentDeleteid(null);
          setDeleteDataObj(null);
        }}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <Grid container spacing={1}>
          <Grid size={12}>
            <Stack flexDirection={"row"} justifyContent={"space-between"}>
              <Typography>{TEXT_SELECT_JOB_ACTIVITIES}</Typography>
              <Stack
                sx={{ cursor: "pointer" }}
                onClick={() => setSortByNearby((prev) => !prev)}
                flexDirection={"row"}
                gap={0.5}>
                <Typography>{TEXT_SORT_BY} </Typography>
                <Typography sx={{ color: CLIENT_COLOR }}>
                  {sortByNearby ? TEXT_NEAR_BY : TEXT_RECENT}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            sx={{
              maxHeight: "300px",
              overflow: "auto"
            }}
            size={12}>
            <Stack spacing={1}>
              {jobs?.length === 0 && (
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "100px", width: "100%" }}>
                  <Typography color={BIGrey}>{TEXT_NO_JOBS_FOUND}</Typography>
                </Stack>
              )}
              {jobs.map((job, index) => (
                <Listing
                  key={job.clientJobId || index}
                  jindex={index}
                  job={job}
                  CLIENT_COLOR={CLIENT_COLOR}
                  handelJobClick={handelJobClick}
                  handelActivityClick={handelActivityClick}
                />
              ))}
            </Stack>
          </Grid>
          <Grid size={12}>
            <LoadingButton
              disabled={isButtonDisabled()}
              onClick={() => {
                formatData();
              }}
              loadingPosition="start"
              startIcon={<></>}
              loading={loading}
              fullWidth
              sx={{
                bgcolor: isButtonDisabled() || loading ? "#e4e4e4" : CLIENT_COLOR,
                color: "white",
                textTransform: "none"
              }}>
              {BUTTON_NEXT}
            </LoadingButton>
          </Grid>
        </Grid>
      )}
    </>
  );
}

const Listing = memo(({ job, jindex, CLIENT_COLOR, handelJobClick, handelActivityClick }) => {
  return (
    <>
      {job.clientJobActivitiesList.length == 0 ? (
        <Stack
          onClick={() => {
            if (job.clientJobActivitiesList.length !== 0) return;
            handelJobClick(job, jindex);
          }}
          sx={{
            cursor: "pointer",
            border: "1px solid #f0f0f0",
            borderRadius: "5px"
          }}
          flexDirection={"row"}
          gap={1}
          alignItems={"center"}>
          <Checkbox
            checked={job.selected}
            sx={{
              "&.Mui-checked": {
                color: CLIENT_COLOR
              }
            }}
          />
          <Typography
            sx={{
              fontWeight: "bold"
            }}>
            {job.clientJobCode} - {job.clientJobName}
          </Typography>
        </Stack>
      ) : (
        <Stack
          sx={{
            padding: "10px",
            borderRadius: "5px"
          }}
          gap={1}>
          <Typography
            sx={{
              fontWeight: "bold"
            }}>
            {job.clientJobCode} - {job.clientJobName}
          </Typography>
          <Stack
            gap={1}
            sx={{
              paddingLeft: "10px"
            }}>
            {job.clientJobActivitiesList?.map((act, aindex) => (
              <Stack
                key={act.id || aindex}
                onClick={() => {
                  handelActivityClick(job, jindex, aindex);
                }}
                sx={{
                  border: "1px solid #f0f0f0",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
                flexDirection={"row"}
                gap={1}
                alignItems={"center"}>
                <Checkbox
                  checked={act.selected}
                  sx={{
                    "&.Mui-checked": {
                      color: CLIENT_COLOR
                    }
                  }}
                />
                <Typography fontWeight={"bold"}>
                  {act.labourActivityCode} - {act.labourActivityName}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}
    </>
  );
});

export default SelectJobModal;
